<div role="alert">
    {{ message }}
    <div class="screen-reader-only">
        {{accessibilityMessage}}
    </div>
</div>